import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHttp from 'services/axiosHttp';
import dayjs from 'dayjs';

export const downloadQrTypeSummary = createAsyncThunk(
  'qrTypeSummary/downloadQrTypeSummary',
  async (params = {}, { rejectWithValue }) => {
    try {
      const apiParams = {
        date: params.date || dayjs().format('YYYY-MM-DD'), 
        location_name: params.location_name || undefined,
        service_name: params.service_name || undefined
      };

      console.log('API Params:', apiParams);
      
      const response = await axiosHttp.get('lcqr/downloadallqrlogs', { 
        params: apiParams,
        responseType: 'blob'
      });
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Download failed');
    }
  }
);

const qrTypeSummeryDownloadSlice = createSlice({
  name: 'QrTypeSummeryDownloadSlice',
  initialState: {
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadQrTypeSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadQrTypeSummary.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(downloadQrTypeSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default qrTypeSummeryDownloadSlice.reducer;
